/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import React, { useMemo } from "react";
// import { useSelector } from "react-redux";
// import { Store } from "../../../store";
import { EventInfo, isSmartPhone } from "../../../utility";
// @ts-expect-error TS7016
import AnchorLink from "react-anchor-link-smooth-scroll";
import { changeStyleWithHosting } from "utility/hosting";
import { useI18n } from "hooks/i18n/i18n";

interface EventThumbnailProps {
  eventInfo: EventInfo;
}
export const EventDetailThumbnail: React.FC<EventThumbnailProps> = (props) => {
  // const location = useSelector((state: Store) => state.router.location);

  const classesEventThumbnail = useMemo(() => eventThumbnailDesign(), []);
  const { t } = useI18n();

  // @ts-expect-error TS7006
  const TopAnchorLink = (props) => {
    return (
      <AnchorLink
        href={props.href}
        offset={() => {
          return isSmartPhone() ? 30 : 100;
        }}
      >
        {props.children}
      </AnchorLink>
    );
  };

  return (
    <div css={classesEventThumbnail.root}>
      <div css={classesEventThumbnail.thumbnailLayout}>
        <img
          css={classesEventThumbnail.thumbnail}
          src={props.eventInfo.thumbnail}
          alt={props.eventInfo.title}
        />
        {props.eventInfo.isOpenStreamingPage ? (
          <TopAnchorLink href="#archive_video">
            <span css={classesEventThumbnail.label}>
              {t("event.status.streamingSale")}
            </span>
          </TopAnchorLink>
        ) : null}
      </div>
    </div>
  );
};

const eventThumbnailDesign = () => {
  const hostingBaseStyleMap = changeStyleWithHosting().baseStyles;

  return {
    root: css`
      background-color: ${hostingBaseStyleMap.baseColor};
    `,
    thumbnailLayout: css`
      position: relative;
      width: 100%;
      max-width: 980px;
      margin: 0 auto;
    `,
    thumbnail: css`
      width: 100%;
    `,
    label: css`
      position: absolute;
      top: 10px;
      left: 10px;
      display: inline-block;
      padding: 4px 15px;
      background-color: #ff0076;
      color: #fff;
      font-size: 14px;
      line-height: 1;
      white-space: nowrap;
    `,
  };
};
